import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询场景地图列表
export const queryModelScenes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatScenes', { ...state.list, loading: true });
    // const res = await $http.post('/item/model/specificmap/list', payload);
    const res = await $http.post('/v1/asset/item/chosenmap/list', payload);
    commit('setMatScenes', { data: res || [] });
  } catch (e) {
    commit('setMatScenes', { data: [] });
  }
};

// 新增场景地图
export const addModelScene: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAddDialog', { ...state.addDialog, loading: true });
    // await $http.post('/item/model/specificmap/add', payload);
    await $http.post('/v1/asset/item/chosenmap/add', payload);
  } finally {
    commit('setAddDialog', { visible: false, loading: false });
  }
};

// 批量删除场景地图
export const deleteModelScene: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/item/model/specificmap/batch/delete', payload);
    await $http.post('/v1/asset/item/chosenmap/delete', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 修改场景物品的坐标信息
export const editCoordinate: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setEditDialog', { ...state.editDialog, loading: true });
    // await $http.post('/item/specificmap/coordinatesInfo/modify', payload);
    await $http.post('/v1/asset/item/modifycoordinchosenmap', payload);
  } finally {
    commit('setEditDialog', { visible: false });
  }
};
